// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.match-history-wrapper .match-history-head .status-component {
  justify-content: flex-end;
}
.match-history-wrapper .export-button-row {
  margin-bottom: 1.5rem;
  display: flex;
  margin-top: 1.5rem;
  justify-content: right;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/MatchHistory/v2/MatchHistorySearch/index.scss"],"names":[],"mappings":"AAEI;EACE,yBAAA;AADN;AAKE;EACE,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;AAHJ","sourcesContent":[".match-history-wrapper {\n  .match-history-head {\n    .status-component {\n      justify-content: flex-end;\n    }\n  }\n\n  .export-button-row {\n    margin-bottom: 1.5rem;\n    display: flex;\n    margin-top: 1.5rem;\n    justify-content: right;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
